import { useAutoAnimate } from "@formkit/auto-animate/react";
import { ClubOnboardingSettingsDTO } from "@gymflow/types";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Switch } from "../../atoms";
import { onboardingSettingsList } from "./constants";

export const OnboardingLeftMenu = ({
  localState,
  setLocalState,
}: {
  localState: ClubOnboardingSettingsDTO;
  setLocalState: (state: ClubOnboardingSettingsDTO) => void;
}) => {
  const { t } = useTranslation();
  const [parent] = useAutoAnimate();
  return (
    <div
      ref={parent}
      className="flex flex-col justify-start gap-6 rounded-2xl border border-gray-200 bg-white p-5 shadow-sm lg:h-full lg:w-1/3"
    >
      <div className="flex flex-col gap-1">
        <div className="text-lg font-semibold text-gray-950">
          {t("page.settings.onboarding.title")}
        </div>
        <div className="text-base font-medium text-gray-500">
          {t("page.settings.onboarding.description")}
        </div>
      </div>

      <div className="flex w-full flex-col gap-3">
        {onboardingSettingsList.map((field) => (
          <FormField
            key={field.name}
            {...field}
            localState={localState}
            setLocalState={setLocalState}
          />
        ))}
      </div>
    </div>
  );
};

const FormField = ({
  name,
  label,
  localState,
  disabled,
  setLocalState,
}: {
  name: keyof ClubOnboardingSettingsDTO;
  label: ReactNode;
  disabled: boolean;
  localState: ClubOnboardingSettingsDTO;
  setLocalState: (state: ClubOnboardingSettingsDTO) => void;
}) => {
  return (
    <div className="flex flex-row items-center justify-start gap-2 rounded-[10px] border border-gray-200 px-3 py-2 shadow-sm">
      <Switch
        value={localState[name] !== "DISABLED"}
        disabled={disabled}
        onChange={async (checked) => {
          setLocalState({
            ...localState,
            [name]: checked ? "OPTIONAL" : "DISABLED",
          });
        }}
        className="h-5 w-9"
      />
      <div className="text-base font-medium text-gray-950">{label}</div>
    </div>
  );
};
